module.exports = __webpack_public_path__ + "static/media/6.06547f3f.JPG";